import { endpointStatistic } from './base.config';

export const bilagskyTeam = {
  // KPI
  getTeamBilagskyKpiData: `${endpointStatistic}/bilagsky-team/kpi`,
  // Overview
  getBilagskyTeamOverviews: `${endpointStatistic}/bilagsky-team/overview`,
  countBilagskyTeamOverviews: `${endpointStatistic}/bilagsky-team/overview/count`,
  getBilagskyTeamOverviewCompanies: `${endpointStatistic}/bilagsky-team/overview/companies`,
  reloadDataOverviewByCompany: `${endpointStatistic}/bilagsky-team/overview/:companyId/reload`,
  updateOverviewField: `${endpointStatistic}/bilagsky-team/overview/update-field`,
};
